import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "actionBar", "count"]
  static values = {
    url: String
  }

  connect() {
    this.updateActionBar()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateActionBar()
  }

  toggle() {
    this.updateActionBar()
  }

  get selectedIds() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }

  get selectedCount() {
    return this.selectedIds.length
  }

  updateActionBar() {
    const count = this.selectedCount

    if (count > 0) {
      this.actionBarTarget.classList.remove("hidden")
      if (this.hasCountTarget) {
        this.countTarget.textContent = count
      }
    } else {
      this.actionBarTarget.classList.add("hidden")
    }

    // Update select all checkbox state
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = count === this.checkboxTargets.length && count > 0
      this.selectAllTarget.indeterminate = count > 0 && count < this.checkboxTargets.length
    }
  }

  async performAction(event) {
    const action = event.params.action
    const ids = this.selectedIds

    if (ids.length === 0) {
      alert("Please select at least one item")
      return
    }

    const message = `Are you sure you want to ${action} ${ids.length} item${ids.length > 1 ? "s" : ""}?`
    if (!confirm(message)) {
      return
    }

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken()
        },
        body: JSON.stringify({ action, ids })
      })

      if (response.ok) {
        // Reload page or update UI
        // Option 1: Reload the page
        window.location.reload()

        // Option 2: Remove items from DOM (uncomment if preferred)
        // ids.forEach(id => {
        //   const element = document.getElementById(`item-${id}`)
        //   if (element) element.remove()
        // })
        // this.updateActionBar()
      } else {
        const data = await response.json()
        alert(`Error: ${data.message || "An error occurred"}`)
      }
    } catch (error) {
      console.error("Bulk action failed:", error)
      alert("An error occurred. Please try again.")
    }
  }

  csrfToken() {
    return document.querySelector("[name='csrf-token']").content
  }
}
